import { PowerBiReportEffects } from 'src/app/root-store/reporting-store/effects/powerbi-report.effects';

export const reportingEffects = [PowerBiReportEffects];
